import _ from "underscore";

import words from "./longerWords.json";

export function getWords(n = 10) {
  return _.sample(words, n);
}
